import classNames from "classnames"
import PropTypes from "prop-types"
import React, { useRef } from "react"

import styles from "./checkbox.less"

const StatelessCheckbox = (props) => {
  const inputElement = useRef()
  const className = classNames(
    styles.checkbox,
    {
      disabled: props.disabled,
      notValid: props.isNotValid,
    },
    props.className,
  )

  const labelClassName = classNames(
    styles.label,
    {
      checked: props.isChecked,
      [props.checkedLabelClassName]: props.isChecked,
      disabled: props.disabled,
      "readspeaker-readable-area": props.readable,
    },
    props.labelClassName,
  )

  let content = null

  if (props.children != null) {
    content = props.children
  } else if (props.label != null && props.html) {
    content = <span dangerouslySetInnerHTML={{ __html: props.label }} />
  } else if (props.label != null) {
    content = props.label
  }

  return (
    <div {...{ className, onMouseDown: props.onMouseDown, title: props.tooltip }}>
      <label
        role="checkbox"
        tabIndex={0}
        className={labelClassName}
        data-qa={props.dataQa}
        id={props.id}
        title={props.title}
        onMouseDown={props.onMouseDown}
        aria-checked={!!inputElement.current && !!inputElement.current.checked}
        onKeyPress={(e) => {
          if (e.key === "Enter" && inputElement.current) {
            inputElement.current.checked = !inputElement.current.checked
            props.onChange && props.onChange(inputElement.current.checked, props.value, e)
          }
        }}>
        <input
          className="rs_preserve"
          type="checkbox"
          disabled={props.disabled}
          onChange={(e) => {
            props.onChange && props.onChange(e.target.checked, props.value, e)
          }}
          id={props.dataQa}
          checked={props.isChecked}
          tabIndex={props.tabIndex}
          autoFocus={props.autoFocus}
          ref={inputElement}
        />
        {content}
      </label>
    </div>
  )
}

StatelessCheckbox.displayName = "StatelessCheckbox"
StatelessCheckbox.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  checkedLabelClassName: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  html: PropTypes.bool,
  value: PropTypes.string,
  isChecked: PropTypes.bool,
  tabIndex: PropTypes.number,
  tooltip: PropTypes.string,
  autoFocus: PropTypes.bool,
  isNotValid: PropTypes.bool,
  dataQa: PropTypes.string,
}

export default StatelessCheckbox
